import { ref as ze, watchEffect as Be, isRef as ge, unref as Ue } from "vue";
const Fe = "2.7.6", Zt = (e) => e, A = (e) => e, Ne = () => `viem@${Fe}`;
class b extends Error {
  constructor(t, r = {}) {
    super(), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ViemError"
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: Ne()
    });
    const n = r.cause instanceof b ? r.cause.details : r.cause?.message ? r.cause.message : r.details, s = r.cause instanceof b && r.cause.docsPath || r.docsPath;
    this.message = [
      t || "An error occurred.",
      "",
      ...r.metaMessages ? [...r.metaMessages, ""] : [],
      ...s ? [
        `Docs: https://viem.sh${s}${r.docsSlug ? `#${r.docsSlug}` : ""}`
      ] : [],
      ...n ? [`Details: ${n}`] : [],
      `Version: ${this.version}`
    ].join(`
`), r.cause && (this.cause = r.cause), this.details = n, this.docsPath = s, this.metaMessages = r.metaMessages, this.shortMessage = t;
  }
  walk(t) {
    return me(this, t);
  }
}
function me(e, t) {
  return t?.(e) ? e : e && typeof e == "object" && "cause" in e ? me(e.cause, t) : t ? null : e;
}
class qe extends b {
  constructor({ max: t, min: r, signed: n, size: s, value: o }) {
    super(`Number "${o}" is not in safe ${s ? `${s * 8}-bit ${n ? "signed" : "unsigned"} ` : ""}integer range ${t ? `(${r} to ${t})` : `(above ${r})`}`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "IntegerOutOfRangeError"
    });
  }
}
class er extends b {
  constructor(t) {
    super(`Bytes value "${t}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidBytesBooleanError"
    });
  }
}
class He extends b {
  constructor({ givenSize: t, maxSize: r }) {
    super(`Size cannot exceed ${r} bytes. Given size: ${t} bytes.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SizeOverflowError"
    });
  }
}
class tr extends b {
  constructor({ offset: t, position: r, size: n }) {
    super(`Slice ${r === "start" ? "starting" : "ending"} at offset "${t}" is out-of-bounds (size: ${n}).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SliceOffsetOutOfBoundsError"
    });
  }
}
class ye extends b {
  constructor({ size: t, targetSize: r, type: n }) {
    super(`${n.charAt(0).toUpperCase()}${n.slice(1).toLowerCase()} size (${t}) exceeds padding size (${r}).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SizeExceedsPaddingSizeError"
    });
  }
}
class rr extends b {
  constructor({ size: t, targetSize: r, type: n }) {
    super(`${n.charAt(0).toUpperCase()}${n.slice(1).toLowerCase()} is expected to be ${r} ${n} long, but is ${t} ${n} long.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidBytesLengthError"
    });
  }
}
function x(e, { dir: t, size: r = 32 } = {}) {
  return typeof e == "string" ? De(e, { dir: t, size: r }) : _e(e, { dir: t, size: r });
}
function De(e, { dir: t, size: r = 32 } = {}) {
  if (r === null)
    return e;
  const n = e.replace("0x", "");
  if (n.length > r * 2)
    throw new ye({
      size: Math.ceil(n.length / 2),
      targetSize: r,
      type: "hex"
    });
  return `0x${n[t === "right" ? "padEnd" : "padStart"](r * 2, "0")}`;
}
function _e(e, { dir: t, size: r = 32 } = {}) {
  if (r === null)
    return e;
  if (e.length > r)
    throw new ye({
      size: e.length,
      targetSize: r,
      type: "bytes"
    });
  const n = new Uint8Array(r);
  for (let s = 0; s < r; s++) {
    const o = t === "right";
    n[o ? s : r - s - 1] = e[o ? s : e.length - s - 1];
  }
  return n;
}
function F(e, { strict: t = !0 } = {}) {
  return !e || typeof e != "string" ? !1 : t ? /^0x[0-9a-fA-F]*$/.test(e) : e.startsWith("0x");
}
function ue(e) {
  return F(e, { strict: !1 }) ? Math.ceil((e.length - 2) / 2) : e.length;
}
function Ge(e, { dir: t = "left" } = {}) {
  let r = typeof e == "string" ? e.replace("0x", "") : e, n = 0;
  for (let s = 0; s < r.length - 1 && r[t === "left" ? s : r.length - s - 1].toString() === "0"; s++)
    n++;
  return r = t === "left" ? r.slice(n) : r.slice(0, r.length - n), typeof e == "string" ? (r.length === 1 && t === "right" && (r = `${r}0`), `0x${r.length % 2 === 1 ? `0${r}` : r}`) : r;
}
const Ke = /* @__PURE__ */ new TextEncoder();
function Ve(e, t = {}) {
  return typeof e == "number" || typeof e == "bigint" ? Je(e, t) : typeof e == "boolean" ? We(e, t) : F(e) ? N(e, t) : we(e, t);
}
function We(e, t = {}) {
  const r = new Uint8Array(1);
  return r[0] = Number(e), typeof t.size == "number" ? (P(r, { size: t.size }), x(r, { size: t.size })) : r;
}
const w = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function ae(e) {
  if (e >= w.zero && e <= w.nine)
    return e - w.zero;
  if (e >= w.A && e <= w.F)
    return e - (w.A - 10);
  if (e >= w.a && e <= w.f)
    return e - (w.a - 10);
}
function N(e, t = {}) {
  let r = e;
  t.size && (P(r, { size: t.size }), r = x(r, { dir: "right", size: t.size }));
  let n = r.slice(2);
  n.length % 2 && (n = `0${n}`);
  const s = n.length / 2, o = new Uint8Array(s);
  for (let i = 0, u = 0; i < s; i++) {
    const d = ae(n.charCodeAt(u++)), a = ae(n.charCodeAt(u++));
    if (d === void 0 || a === void 0)
      throw new b(`Invalid byte sequence ("${n[u - 2]}${n[u - 1]}" in "${n}").`);
    o[i] = d * 16 + a;
  }
  return o;
}
function Je(e, t) {
  const r = Pe(e, t);
  return N(r);
}
function we(e, t = {}) {
  const r = Ke.encode(e);
  return typeof t.size == "number" ? (P(r, { size: t.size }), x(r, { dir: "right", size: t.size })) : r;
}
function P(e, { size: t }) {
  if (ue(e) > t)
    throw new He({
      givenSize: ue(e),
      maxSize: t
    });
}
function Xe(e, t = {}) {
  const { signed: r } = t;
  t.size && P(e, { size: t.size });
  const n = BigInt(e);
  if (!r)
    return n;
  const s = (e.length - 2) / 2, o = (1n << BigInt(s) * 8n - 1n) - 1n;
  return n <= o ? n : n - BigInt(`0x${"f".padStart(s * 2, "f")}`) - 1n;
}
function nr(e, t = {}) {
  return Number(Xe(e, t));
}
function sr(e, t = {}) {
  let r = N(e);
  return t.size && (P(r, { size: t.size }), r = Ge(r, { dir: "right" })), new TextDecoder().decode(r);
}
const Qe = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function Ye(e, t = {}) {
  return typeof e == "number" || typeof e == "bigint" ? Pe(e, t) : typeof e == "string" ? tt(e, t) : typeof e == "boolean" ? Ze(e, t) : ve(e, t);
}
function Ze(e, t = {}) {
  const r = `0x${Number(e)}`;
  return typeof t.size == "number" ? (P(r, { size: t.size }), x(r, { size: t.size })) : r;
}
function ve(e, t = {}) {
  let r = "";
  for (let s = 0; s < e.length; s++)
    r += Qe[e[s]];
  const n = `0x${r}`;
  return typeof t.size == "number" ? (P(n, { size: t.size }), x(n, { dir: "right", size: t.size })) : n;
}
function Pe(e, t = {}) {
  const { signed: r, size: n } = t, s = BigInt(e);
  let o;
  n ? r ? o = (1n << BigInt(n) * 8n - 1n) - 1n : o = 2n ** (BigInt(n) * 8n) - 1n : typeof e == "number" && (o = BigInt(Number.MAX_SAFE_INTEGER));
  const i = typeof o == "bigint" && r ? -o - 1n : 0;
  if (o && s > o || s < i) {
    const d = typeof e == "bigint" ? "n" : "";
    throw new qe({
      max: o ? `${o}${d}` : void 0,
      min: `${i}${d}`,
      signed: r,
      size: n,
      value: `${e}${d}`
    });
  }
  const u = `0x${(r && s < 0 ? (1n << BigInt(n * 8)) + BigInt(s) : s).toString(16)}`;
  return n ? x(u, { size: n }) : u;
}
const et = /* @__PURE__ */ new TextEncoder();
function tt(e, t = {}) {
  const r = et.encode(e);
  return ve(r, t);
}
class rt extends b {
  constructor({ address: t }) {
    super(`Address "${t}" is invalid.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidAddressError"
    });
  }
}
const nt = /^0x[a-fA-F0-9]{40}$/;
function st(e) {
  return nt.test(e);
}
function or(e) {
  return typeof e == "string" ? { address: e, type: "json-rpc" } : e;
}
const R = (e, t, r) => JSON.stringify(e, (n, s) => {
  const o = typeof s == "bigint" ? s.toString() : s;
  return typeof t == "function" ? t(n, o) : o;
}, r);
class ir extends b {
  constructor({ body: t, details: r, headers: n, status: s, url: o }) {
    super("HTTP request failed.", {
      details: r,
      metaMessages: [
        s && `Status: ${s}`,
        `URL: ${A(o)}`,
        t && `Request body: ${R(t)}`
      ].filter(Boolean)
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "HttpRequestError"
    }), Object.defineProperty(this, "body", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "headers", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "status", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "url", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.body = t, this.headers = n, this.status = s, this.url = o;
  }
}
class ur extends b {
  constructor({ body: t, details: r, url: n }) {
    super("WebSocket request failed.", {
      details: r,
      metaMessages: [`URL: ${A(n)}`, `Request body: ${R(t)}`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WebSocketRequestError"
    });
  }
}
class ot extends b {
  constructor({ body: t, error: r, url: n }) {
    super("RPC Request failed.", {
      cause: r,
      details: r.message,
      metaMessages: [`URL: ${A(n)}`, `Request body: ${R(t)}`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcRequestError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.code = r.code;
  }
}
class ar extends b {
  constructor({ body: t, url: r }) {
    super("The request took too long to respond.", {
      details: "The request timed out.",
      metaMessages: [`URL: ${A(r)}`, `Request body: ${R(t)}`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TimeoutError"
    });
  }
}
const it = -1;
class g extends b {
  constructor(t, { code: r, docsPath: n, metaMessages: s, shortMessage: o }) {
    super(o, {
      cause: t,
      docsPath: n,
      metaMessages: s || t?.metaMessages
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = t.name, this.code = t instanceof ot ? t.code : r ?? it;
  }
}
class E extends g {
  constructor(t, r) {
    super(t, r), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ProviderRpcError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = r.data;
  }
}
class q extends g {
  constructor(t) {
    super(t, {
      code: q.code,
      shortMessage: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ParseRpcError"
    });
  }
}
Object.defineProperty(q, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32700
});
class H extends g {
  constructor(t) {
    super(t, {
      code: H.code,
      shortMessage: "JSON is not a valid request object."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidRequestRpcError"
    });
  }
}
Object.defineProperty(H, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32600
});
class D extends g {
  constructor(t) {
    super(t, {
      code: D.code,
      shortMessage: "The method does not exist / is not available."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "MethodNotFoundRpcError"
    });
  }
}
Object.defineProperty(D, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32601
});
class _ extends g {
  constructor(t) {
    super(t, {
      code: _.code,
      shortMessage: [
        "Invalid parameters were provided to the RPC method.",
        "Double check you have provided the correct parameters."
      ].join(`
`)
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidParamsRpcError"
    });
  }
}
Object.defineProperty(_, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32602
});
class G extends g {
  constructor(t) {
    super(t, {
      code: G.code,
      shortMessage: "An internal error was received."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InternalRpcError"
    });
  }
}
Object.defineProperty(G, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32603
});
class K extends g {
  constructor(t) {
    super(t, {
      code: K.code,
      shortMessage: [
        "Missing or invalid parameters.",
        "Double check you have provided the correct parameters."
      ].join(`
`)
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidInputRpcError"
    });
  }
}
Object.defineProperty(K, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32e3
});
class V extends g {
  constructor(t) {
    super(t, {
      code: V.code,
      shortMessage: "Requested resource not found."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ResourceNotFoundRpcError"
    });
  }
}
Object.defineProperty(V, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32001
});
class W extends g {
  constructor(t) {
    super(t, {
      code: W.code,
      shortMessage: "Requested resource not available."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ResourceUnavailableRpcError"
    });
  }
}
Object.defineProperty(W, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32002
});
class J extends g {
  constructor(t) {
    super(t, {
      code: J.code,
      shortMessage: "Transaction creation failed."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TransactionRejectedRpcError"
    });
  }
}
Object.defineProperty(J, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32003
});
class X extends g {
  constructor(t) {
    super(t, {
      code: X.code,
      shortMessage: "Method is not implemented."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "MethodNotSupportedRpcError"
    });
  }
}
Object.defineProperty(X, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32004
});
class Q extends g {
  constructor(t) {
    super(t, {
      code: Q.code,
      shortMessage: "Request exceeds defined limit."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "LimitExceededRpcError"
    });
  }
}
Object.defineProperty(Q, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32005
});
class Y extends g {
  constructor(t) {
    super(t, {
      code: Y.code,
      shortMessage: "Version of JSON-RPC protocol is not supported."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "JsonRpcVersionUnsupportedError"
    });
  }
}
Object.defineProperty(Y, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32006
});
class Z extends E {
  constructor(t) {
    super(t, {
      code: Z.code,
      shortMessage: "User rejected the request."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UserRejectedRequestError"
    });
  }
}
Object.defineProperty(Z, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4001
});
class ee extends E {
  constructor(t) {
    super(t, {
      code: ee.code,
      shortMessage: "The requested method and/or account has not been authorized by the user."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnauthorizedProviderError"
    });
  }
}
Object.defineProperty(ee, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4100
});
class te extends E {
  constructor(t) {
    super(t, {
      code: te.code,
      shortMessage: "The Provider does not support the requested method."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnsupportedProviderMethodError"
    });
  }
}
Object.defineProperty(te, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4200
});
class re extends E {
  constructor(t) {
    super(t, {
      code: re.code,
      shortMessage: "The Provider is disconnected from all chains."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ProviderDisconnectedError"
    });
  }
}
Object.defineProperty(re, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4900
});
class ne extends E {
  constructor(t) {
    super(t, {
      code: ne.code,
      shortMessage: "The Provider is not connected to the requested chain."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ChainDisconnectedError"
    });
  }
}
Object.defineProperty(ne, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4901
});
class se extends E {
  constructor(t) {
    super(t, {
      code: se.code,
      shortMessage: "An error occurred when attempting to switch chain."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SwitchChainError"
    });
  }
}
Object.defineProperty(se, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4902
});
class cr extends g {
  constructor(t) {
    super(t, {
      shortMessage: "An unknown RPC error occurred."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownRpcError"
    });
  }
}
function ce(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function Oe(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function le(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function ut(e, t) {
  Oe(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error(`digestInto() expects output buffer of length at least ${r}`);
}
const $ = /* @__PURE__ */ BigInt(2 ** 32 - 1), fe = /* @__PURE__ */ BigInt(32);
function at(e, t = !1) {
  return t ? { h: Number(e & $), l: Number(e >> fe & $) } : { h: Number(e >> fe & $) | 0, l: Number(e & $) | 0 };
}
function ct(e, t = !1) {
  let r = new Uint32Array(e.length), n = new Uint32Array(e.length);
  for (let s = 0; s < e.length; s++) {
    const { h: o, l: i } = at(e[s], t);
    [r[s], n[s]] = [o, i];
  }
  return [r, n];
}
const lt = (e, t, r) => e << r | t >>> 32 - r, ft = (e, t, r) => t << r | e >>> 32 - r, dt = (e, t, r) => t << r - 32 | e >>> 64 - r, ht = (e, t, r) => e << r - 32 | t >>> 64 - r;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const bt = (e) => e instanceof Uint8Array, pt = (e) => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), gt = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!gt)
  throw new Error("Non little-endian hardware is not supported");
function mt(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function xe(e) {
  if (typeof e == "string" && (e = mt(e)), !bt(e))
    throw new Error(`expected Uint8Array, got ${typeof e}`);
  return e;
}
class yt {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function wt(e) {
  const t = (n) => e().update(xe(n)).digest(), r = e();
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = () => e(), t;
}
const [Ee, je, Se] = [[], [], []], vt = /* @__PURE__ */ BigInt(0), S = /* @__PURE__ */ BigInt(1), Pt = /* @__PURE__ */ BigInt(2), Ot = /* @__PURE__ */ BigInt(7), xt = /* @__PURE__ */ BigInt(256), Et = /* @__PURE__ */ BigInt(113);
for (let e = 0, t = S, r = 1, n = 0; e < 24; e++) {
  [r, n] = [n, (2 * r + 3 * n) % 5], Ee.push(2 * (5 * n + r)), je.push((e + 1) * (e + 2) / 2 % 64);
  let s = vt;
  for (let o = 0; o < 7; o++)
    t = (t << S ^ (t >> Ot) * Et) % xt, t & Pt && (s ^= S << (S << /* @__PURE__ */ BigInt(o)) - S);
  Se.push(s);
}
const [jt, St] = /* @__PURE__ */ ct(Se, !0), de = (e, t, r) => r > 32 ? dt(e, t, r) : lt(e, t, r), he = (e, t, r) => r > 32 ? ht(e, t, r) : ft(e, t, r);
function $t(e, t = 24) {
  const r = new Uint32Array(10);
  for (let n = 24 - t; n < 24; n++) {
    for (let i = 0; i < 10; i++)
      r[i] = e[i] ^ e[i + 10] ^ e[i + 20] ^ e[i + 30] ^ e[i + 40];
    for (let i = 0; i < 10; i += 2) {
      const u = (i + 8) % 10, d = (i + 2) % 10, a = r[d], c = r[d + 1], p = de(a, c, 1) ^ r[u], l = he(a, c, 1) ^ r[u + 1];
      for (let f = 0; f < 50; f += 10)
        e[i + f] ^= p, e[i + f + 1] ^= l;
    }
    let s = e[2], o = e[3];
    for (let i = 0; i < 24; i++) {
      const u = je[i], d = de(s, o, u), a = he(s, o, u), c = Ee[i];
      s = e[c], o = e[c + 1], e[c] = d, e[c + 1] = a;
    }
    for (let i = 0; i < 50; i += 10) {
      for (let u = 0; u < 10; u++)
        r[u] = e[i + u];
      for (let u = 0; u < 10; u++)
        e[i + u] ^= ~r[(u + 2) % 10] & r[(u + 4) % 10];
    }
    e[0] ^= jt[n], e[1] ^= St[n];
  }
  r.fill(0);
}
class oe extends yt {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(t, r, n, s = !1, o = 24) {
    if (super(), this.blockLen = t, this.suffix = r, this.outputLen = n, this.enableXOF = s, this.rounds = o, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, ce(n), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = pt(this.state);
  }
  keccak() {
    $t(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(t) {
    le(this);
    const { blockLen: r, state: n } = this;
    t = xe(t);
    const s = t.length;
    for (let o = 0; o < s; ) {
      const i = Math.min(r - this.pos, s - o);
      for (let u = 0; u < i; u++)
        n[this.pos++] ^= t[o++];
      this.pos === r && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: t, suffix: r, pos: n, blockLen: s } = this;
    t[n] ^= r, r & 128 && n === s - 1 && this.keccak(), t[s - 1] ^= 128, this.keccak();
  }
  writeInto(t) {
    le(this, !1), Oe(t), this.finish();
    const r = this.state, { blockLen: n } = this;
    for (let s = 0, o = t.length; s < o; ) {
      this.posOut >= n && this.keccak();
      const i = Math.min(n - this.posOut, o - s);
      t.set(r.subarray(this.posOut, this.posOut + i), s), this.posOut += i, s += i;
    }
    return t;
  }
  xofInto(t) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(t);
  }
  xof(t) {
    return ce(t), this.xofInto(new Uint8Array(t));
  }
  digestInto(t) {
    if (ut(t, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(t), this.destroy(), t;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(t) {
    const { blockLen: r, suffix: n, outputLen: s, rounds: o, enableXOF: i } = this;
    return t || (t = new oe(r, n, s, i, o)), t.state32.set(this.state32), t.pos = this.pos, t.posOut = this.posOut, t.finished = this.finished, t.rounds = o, t.suffix = n, t.outputLen = s, t.enableXOF = i, t.destroyed = this.destroyed, t;
  }
}
const Mt = (e, t, r) => wt(() => new oe(t, e, r)), At = /* @__PURE__ */ Mt(1, 136, 256 / 8);
function Rt(e, t) {
  const r = t || "hex", n = At(F(e, { strict: !1 }) ? Ve(e) : e);
  return r === "bytes" ? n : Ye(n);
}
function Ct(e, t) {
  const r = t ? `${t}${e.toLowerCase()}` : e.substring(2).toLowerCase(), n = Rt(we(r), "bytes"), s = (t ? r.substring(`${t}0x`.length) : r).split("");
  for (let o = 0; o < 40; o += 2)
    n[o >> 1] >> 4 >= 8 && s[o] && (s[o] = s[o].toUpperCase()), (n[o >> 1] & 15) >= 8 && s[o + 1] && (s[o + 1] = s[o + 1].toUpperCase());
  return `0x${s.join("")}`;
}
function lr(e, t) {
  if (!st(e))
    throw new rt({ address: e });
  return Ct(e, t);
}
const I = /* @__PURE__ */ new Map();
function fr({ fn: e, id: t, shouldSplitBatch: r, wait: n = 0, sort: s }) {
  const o = async () => {
    const c = d();
    i();
    const p = c.map(({ args: l }) => l);
    p.length !== 0 && e(p).then((l) => {
      s && Array.isArray(l) && l.sort(s);
      for (let f = 0; f < c.length; f++) {
        const { pendingPromise: y } = c[f];
        y.resolve?.([l[f], l]);
      }
    }).catch((l) => {
      for (let f = 0; f < c.length; f++) {
        const { pendingPromise: y } = c[f];
        y.reject?.(l);
      }
    });
  }, i = () => I.delete(t), u = () => d().map(({ args: c }) => c), d = () => I.get(t) || [], a = (c) => I.set(t, [...d(), c]);
  return {
    flush: i,
    async schedule(c) {
      const p = {}, l = new Promise((j, h) => {
        p.resolve = j, p.reject = h;
      });
      return r?.([...u(), c]) && o(), d().length > 0 ? (a({ args: c, pendingPromise: p }), l) : (a({ args: c, pendingPromise: p }), setTimeout(o, n), l);
    }
  };
}
const Tt = "2.6.1", It = () => `@wagmi/core@${Tt}`;
var $e = function(e, t, r, n) {
  if (r === "a" && !n)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !n : !t.has(e))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(e) : n ? n.value : t.get(e);
}, M, Me;
let O = class L extends Error {
  get docsBaseUrl() {
    return "https://wagmi.sh/core";
  }
  get version() {
    return It();
  }
  constructor(t, r = {}) {
    super(), M.add(this), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WagmiCoreError"
    });
    const n = r.cause instanceof L ? r.cause.details : r.cause?.message ? r.cause.message : r.details, s = r.cause instanceof L && r.cause.docsPath || r.docsPath;
    this.message = [
      t || "An error occurred.",
      "",
      ...r.metaMessages ? [...r.metaMessages, ""] : [],
      ...s ? [
        `Docs: ${this.docsBaseUrl}${s}.html${r.docsSlug ? `#${r.docsSlug}` : ""}`
      ] : [],
      ...n ? [`Details: ${n}`] : [],
      `Version: ${this.version}`
    ].join(`
`), r.cause && (this.cause = r.cause), this.details = n, this.docsPath = s, this.metaMessages = r.metaMessages, this.shortMessage = t;
  }
  walk(t) {
    return $e(this, M, "m", Me).call(this, this, t);
  }
};
M = /* @__PURE__ */ new WeakSet(), Me = function e(t, r) {
  return r?.(t) ? t : t.cause ? $e(this, M, "m", e).call(this, t.cause, r) : t;
};
class dr extends O {
  constructor() {
    super("Chain not configured."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ChainNotConfiguredError"
    });
  }
}
class hr extends O {
  constructor() {
    super("Connector already connected."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorAlreadyConnectedError"
    });
  }
}
class br extends O {
  constructor() {
    super("Connector not connected."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorNotConnectedError"
    });
  }
}
class pr extends O {
  constructor() {
    super("Connector not found."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorNotFoundError"
    });
  }
}
class gr extends O {
  constructor({ address: t, connector: r }) {
    super(`Account "${t}" not found for connector "${r.name}".`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorAccountNotFoundError"
    });
  }
}
class mr extends O {
  constructor() {
    super("Provider not found."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ProviderNotFoundError"
    });
  }
}
class yr extends O {
  constructor({ connector: t }) {
    super(`"${t.name}" does not support programmatic chain switching.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SwitchChainNotSupportedError"
    });
  }
}
function wr(e) {
  if (typeof e == "string")
    return Number.parseInt(e, e.trim().substring(0, 2) === "0x" ? 16 : 10);
  if (typeof e == "bigint")
    return Number(e);
  if (typeof e == "number")
    return e;
  throw new Error(`Cannot normalize chainId "${e}" of type "${typeof e}"`);
}
let k = !1;
async function kt(e, t = {}) {
  if (k)
    return [];
  k = !0, e.setState((a) => ({
    ...a,
    status: a.current ? "reconnecting" : "connecting"
  }));
  const r = [];
  if (t.connectors?.length)
    for (const a of t.connectors) {
      let c;
      typeof a == "function" ? c = e._internal.connectors.setup(a) : c = a, r.push(c);
    }
  else
    r.push(...e.connectors);
  const n = await e.storage?.getItem("recentConnectorId"), s = {};
  for (const [, a] of e.state.connections)
    s[a.connector.id] = 1;
  n && (s[n] = 0);
  const o = Object.keys(s).length > 0 ? (
    // .toSorted()
    [...r].sort((a, c) => (s[a.id] ?? 10) - (s[c.id] ?? 10))
  ) : r;
  let i = !1;
  const u = [], d = [];
  for (const a of o) {
    const c = await a.getProvider();
    if (!c || d.some((f) => f === c) || !await a.isAuthorized())
      continue;
    const l = await a.connect({ isReconnecting: !0 }).catch(() => null);
    l && (a.emitter.off("connect", e._internal.events.connect), a.emitter.on("change", e._internal.events.change), a.emitter.on("disconnect", e._internal.events.disconnect), e.setState((f) => {
      const y = new Map(i ? f.connections : /* @__PURE__ */ new Map()).set(a.uid, { accounts: l.accounts, chainId: l.chainId, connector: a });
      return {
        ...f,
        current: i ? f.current : a.uid,
        connections: y
      };
    }), u.push({
      accounts: l.accounts,
      chainId: l.chainId,
      connector: a
    }), d.push(c), i = !0);
  }
  return i ? e.setState((a) => ({ ...a, status: "connected" })) : e.setState((a) => ({
    ...a,
    connections: /* @__PURE__ */ new Map(),
    current: void 0,
    status: "disconnected"
  })), k = !1, u;
}
function Lt(e, t) {
  const { initialState: r, reconnectOnMount: n } = t;
  return r && e.setState({
    ...r,
    connections: n ? r.connections : /* @__PURE__ */ new Map(),
    status: n ? "reconnecting" : "disconnected"
  }), {
    async onMount() {
      if (e._internal.ssr) {
        await e._internal.store.persist.rehydrate();
        const s = e._internal.mipd?.getProviders().map(e._internal.connectors.providerDetailToConnector).map(e._internal.connectors.setup);
        e._internal.connectors.setState((o) => [
          ...o,
          ...s ?? []
        ]);
      }
      n ? kt(e) : e.storage && e.setState((s) => ({
        ...s,
        connections: /* @__PURE__ */ new Map()
      }));
    }
  };
}
const zt = "use-wagmi-config", vr = {
  install: (e, t) => {
    const { config: r, initialState: n, reconnectOnMount: s = !0 } = t, { onMount: o } = Lt(r, {
      initialState: n,
      reconnectOnMount: s
    });
    r._internal.ssr || o();
    const i = ze(!0);
    Be((u) => {
      i.value && r._internal.ssr && (o(), u(() => {
        i.value = !1;
      }));
    }), e.provide(zt, r);
  }
};
var Ae = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, C = typeof window > "u" || "Deno" in window;
function Pr() {
}
function Or(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Bt(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function xr(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function Er(e, t) {
  const {
    type: r = "all",
    exact: n,
    fetchStatus: s,
    predicate: o,
    queryKey: i,
    stale: u
  } = e;
  if (i) {
    if (n) {
      if (t.queryHash !== Ut(i, t.options))
        return !1;
    } else if (!ie(t.queryKey, i))
      return !1;
  }
  if (r !== "all") {
    const d = t.isActive();
    if (r === "active" && !d || r === "inactive" && d)
      return !1;
  }
  return !(typeof u == "boolean" && t.isStale() !== u || typeof s < "u" && s !== t.state.fetchStatus || o && !o(t));
}
function jr(e, t) {
  const { exact: r, status: n, predicate: s, mutationKey: o } = e;
  if (o) {
    if (!t.options.mutationKey)
      return !1;
    if (r) {
      if (z(t.options.mutationKey) !== z(o))
        return !1;
    } else if (!ie(t.options.mutationKey, o))
      return !1;
  }
  return !(n && t.state.status !== n || s && !s(t));
}
function Ut(e, t) {
  return (t?.queryKeyHashFn || z)(e);
}
function z(e) {
  return JSON.stringify(
    e,
    (t, r) => B(r) ? Object.keys(r).sort().reduce((n, s) => (n[s] = r[s], n), {}) : r
  );
}
function ie(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((r) => !ie(e[r], t[r])) : !1;
}
function Re(e, t) {
  if (e === t)
    return e;
  const r = be(e) && be(t);
  if (r || B(e) && B(t)) {
    const n = r ? e : Object.keys(e), s = n.length, o = r ? t : Object.keys(t), i = o.length, u = r ? [] : {};
    let d = 0;
    for (let a = 0; a < i; a++) {
      const c = r ? a : o[a];
      !r && e[c] === void 0 && t[c] === void 0 && n.includes(c) ? (u[c] = void 0, d++) : (u[c] = Re(e[c], t[c]), u[c] === e[c] && e[c] !== void 0 && d++);
    }
    return s === i && d === s ? e : u;
  }
  return t;
}
function Sr(e, t) {
  if (e && !t || t && !e)
    return !1;
  for (const r in e)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function be(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function B(e) {
  if (!pe(e))
    return !1;
  const t = e.constructor;
  if (typeof t > "u")
    return !0;
  const r = t.prototype;
  return !(!pe(r) || !r.hasOwnProperty("isPrototypeOf"));
}
function pe(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Ft(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function $r(e, t, r) {
  return typeof r.structuralSharing == "function" ? r.structuralSharing(e, t) : r.structuralSharing !== !1 ? Re(e, t) : t;
}
function Mr(e, t, r = 0) {
  const n = [...e, t];
  return r && n.length > r ? n.slice(1) : n;
}
function Ar(e, t, r = 0) {
  const n = [t, ...e];
  return r && n.length > r ? n.slice(0, -1) : n;
}
var Nt = class extends Ae {
  #e;
  #r;
  #t;
  constructor() {
    super(), this.#t = (e) => {
      if (!C && window.addEventListener) {
        const t = () => e();
        return window.addEventListener("visibilitychange", t, !1), () => {
          window.removeEventListener("visibilitychange", t);
        };
      }
    };
  }
  onSubscribe() {
    this.#r || this.setEventListener(this.#t);
  }
  onUnsubscribe() {
    this.hasListeners() || (this.#r?.(), this.#r = void 0);
  }
  setEventListener(e) {
    this.#t = e, this.#r?.(), this.#r = e((t) => {
      typeof t == "boolean" ? this.setFocused(t) : this.onFocus();
    });
  }
  setFocused(e) {
    this.#e !== e && (this.#e = e, this.onFocus());
  }
  onFocus() {
    this.listeners.forEach((e) => {
      e();
    });
  }
  isFocused() {
    return typeof this.#e == "boolean" ? this.#e : globalThis.document?.visibilityState !== "hidden";
  }
}, qt = new Nt(), Ht = class extends Ae {
  #e = !0;
  #r;
  #t;
  constructor() {
    super(), this.#t = (e) => {
      if (!C && window.addEventListener) {
        const t = () => e(!0), r = () => e(!1);
        return window.addEventListener("online", t, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", t), window.removeEventListener("offline", r);
        };
      }
    };
  }
  onSubscribe() {
    this.#r || this.setEventListener(this.#t);
  }
  onUnsubscribe() {
    this.hasListeners() || (this.#r?.(), this.#r = void 0);
  }
  setEventListener(e) {
    this.#t = e, this.#r?.(), this.#r = e(this.setOnline.bind(this));
  }
  setOnline(e) {
    this.#e !== e && (this.#e = e, this.listeners.forEach((r) => {
      r(e);
    }));
  }
  isOnline() {
    return this.#e;
  }
}, Ce = new Ht();
function Dt(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function Te(e) {
  return (e ?? "online") === "online" ? Ce.isOnline() : !0;
}
var Ie = class {
  constructor(e) {
    this.revert = e?.revert, this.silent = e?.silent;
  }
};
function Rr(e) {
  return e instanceof Ie;
}
function _t(e) {
  let t = !1, r = 0, n = !1, s, o, i;
  const u = new Promise((h, m) => {
    o = h, i = m;
  }), d = (h) => {
    n || (f(new Ie(h)), e.abort?.());
  }, a = () => {
    t = !0;
  }, c = () => {
    t = !1;
  }, p = () => !qt.isFocused() || e.networkMode !== "always" && !Ce.isOnline(), l = (h) => {
    n || (n = !0, e.onSuccess?.(h), s?.(), o(h));
  }, f = (h) => {
    n || (n = !0, e.onError?.(h), s?.(), i(h));
  }, y = () => new Promise((h) => {
    s = (m) => {
      const v = n || !p();
      return v && h(m), v;
    }, e.onPause?.();
  }).then(() => {
    s = void 0, n || e.onContinue?.();
  }), j = () => {
    if (n)
      return;
    let h;
    try {
      h = e.fn();
    } catch (m) {
      h = Promise.reject(m);
    }
    Promise.resolve(h).then(l).catch((m) => {
      if (n)
        return;
      const v = e.retry ?? (C ? 0 : 3), T = e.retryDelay ?? Dt, ke = typeof T == "function" ? T(r, m) : T, Le = v === !0 || typeof v == "number" && r < v || typeof v == "function" && v(r, m);
      if (t || !Le) {
        f(m);
        return;
      }
      r++, e.onFail?.(r, m), Ft(ke).then(() => {
        if (p())
          return y();
      }).then(() => {
        t ? f(m) : j();
      });
    });
  };
  return Te(e.networkMode) ? j() : y().then(j), {
    promise: u,
    cancel: d,
    continue: () => s?.() ? u : Promise.resolve(),
    cancelRetry: a,
    continueRetry: c
  };
}
function Gt() {
  let e = [], t = 0, r = (l) => {
    l();
  }, n = (l) => {
    l();
  }, s = (l) => setTimeout(l, 0);
  const o = (l) => {
    s = l;
  }, i = (l) => {
    let f;
    t++;
    try {
      f = l();
    } finally {
      t--, t || a();
    }
    return f;
  }, u = (l) => {
    t ? e.push(l) : s(() => {
      r(l);
    });
  }, d = (l) => (...f) => {
    u(() => {
      l(...f);
    });
  }, a = () => {
    const l = e;
    e = [], l.length && s(() => {
      n(() => {
        l.forEach((f) => {
          r(f);
        });
      });
    });
  };
  return {
    batch: i,
    batchCalls: d,
    schedule: u,
    setNotifyFunction: (l) => {
      r = l;
    },
    setBatchNotifyFunction: (l) => {
      n = l;
    },
    setScheduler: o
  };
}
var Kt = Gt(), Vt = class {
  #e;
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), Bt(this.gcTime) && (this.#e = setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(e) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      e ?? (C ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    this.#e && (clearTimeout(this.#e), this.#e = void 0);
  }
}, Cr = class extends Vt {
  constructor(e) {
    super(), this.mutationId = e.mutationId, this.#r = e.defaultOptions, this.#t = e.mutationCache, this.#e = [], this.state = e.state || Wt(), this.setOptions(e.options), this.scheduleGc();
  }
  #e;
  #r;
  #t;
  #s;
  setOptions(e) {
    this.options = { ...this.#r, ...e }, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(e) {
    this.#e.includes(e) || (this.#e.push(e), this.clearGcTimeout(), this.#t.notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.#e = this.#e.filter((t) => t !== e), this.scheduleGc(), this.#t.notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    this.#e.length || (this.state.status === "pending" ? this.scheduleGc() : this.#t.remove(this));
  }
  continue() {
    return this.#s?.continue() ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(e) {
    const t = () => (this.#s = _t({
      fn: () => this.options.mutationFn ? this.options.mutationFn(e) : Promise.reject(new Error("No mutationFn found")),
      onFail: (n, s) => {
        this.#n({ type: "failed", failureCount: n, error: s });
      },
      onPause: () => {
        this.#n({ type: "pause" });
      },
      onContinue: () => {
        this.#n({ type: "continue" });
      },
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode
    }), this.#s.promise), r = this.state.status === "pending";
    try {
      if (!r) {
        this.#n({ type: "pending", variables: e }), await this.#t.config.onMutate?.(
          e,
          this
        );
        const s = await this.options.onMutate?.(e);
        s !== this.state.context && this.#n({
          type: "pending",
          context: s,
          variables: e
        });
      }
      const n = await t();
      return await this.#t.config.onSuccess?.(
        n,
        e,
        this.state.context,
        this
      ), await this.options.onSuccess?.(n, e, this.state.context), await this.#t.config.onSettled?.(
        n,
        null,
        this.state.variables,
        this.state.context,
        this
      ), await this.options.onSettled?.(n, null, e, this.state.context), this.#n({ type: "success", data: n }), n;
    } catch (n) {
      try {
        throw await this.#t.config.onError?.(
          n,
          e,
          this.state.context,
          this
        ), await this.options.onError?.(
          n,
          e,
          this.state.context
        ), await this.#t.config.onSettled?.(
          void 0,
          n,
          this.state.variables,
          this.state.context,
          this
        ), await this.options.onSettled?.(
          void 0,
          n,
          e,
          this.state.context
        ), n;
      } finally {
        this.#n({ type: "error", error: n });
      }
    }
  }
  #n(e) {
    const t = (r) => {
      switch (e.type) {
        case "failed":
          return {
            ...r,
            failureCount: e.failureCount,
            failureReason: e.error
          };
        case "pause":
          return {
            ...r,
            isPaused: !0
          };
        case "continue":
          return {
            ...r,
            isPaused: !1
          };
        case "pending":
          return {
            ...r,
            context: e.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !Te(this.options.networkMode),
            status: "pending",
            variables: e.variables,
            submittedAt: Date.now()
          };
        case "success":
          return {
            ...r,
            data: e.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...r,
            data: void 0,
            error: e.error,
            failureCount: r.failureCount + 1,
            failureReason: e.error,
            isPaused: !1,
            status: "error"
          };
      }
    };
    this.state = t(this.state), Kt.batch(() => {
      this.#e.forEach((r) => {
        r.onMutationUpdate(e);
      }), this.#t.notify({
        mutation: this,
        type: "updated",
        action: e
      });
    });
  }
};
function Wt() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var Jt = "VUE_QUERY_CLIENT";
function Tr(e) {
  const t = e ? `:${e}` : "";
  return `${Jt}${t}`;
}
function Ir(e, t) {
  Object.keys(e).forEach((r) => {
    e[r] = t[r];
  });
}
function U(e, t) {
  if (t) {
    const r = t(e);
    if (r === void 0 && ge(e) || r !== void 0)
      return r;
  }
  if (Array.isArray(e))
    return e.map((r) => U(r, t));
  if (typeof e == "object" && Qt(e)) {
    const r = Object.entries(e).map(([n, s]) => [
      n,
      U(s, t)
    ]);
    return Object.fromEntries(r);
  }
  return e;
}
function Xt(e) {
  return U(e, (t) => {
    if (ge(t))
      return Xt(Ue(t));
  });
}
function Qt(e) {
  if (Object.prototype.toString.call(e) !== "[object Object]")
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function kr(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
export {
  gr as $,
  F as A,
  b as B,
  dr as C,
  ve as D,
  Ve as E,
  Rt as F,
  we as G,
  Ye as H,
  Ge as I,
  ue as J,
  R as K,
  K as L,
  Cr as M,
  fr as N,
  ar as O,
  mr as P,
  st as Q,
  Vt as R,
  Ae as S,
  J as T,
  Z as U,
  rt as V,
  ur as W,
  Ct as X,
  tt as Y,
  ot as Z,
  br as _,
  Kt as a,
  sr as a0,
  re as a1,
  ne as a2,
  kt as a3,
  Re as a4,
  zt as a5,
  hr as a6,
  pr as a7,
  yr as a8,
  ir as a9,
  Wt as aA,
  Ir as aB,
  kr as aC,
  A as aD,
  cr as aa,
  te as ab,
  ee as ac,
  Y as ad,
  Q as ae,
  X as af,
  W as ag,
  V as ah,
  G as ai,
  _ as aj,
  D as ak,
  H as al,
  q as am,
  Ar as an,
  Mr as ao,
  tr as ap,
  De as aq,
  Ze as ar,
  P as as,
  er as at,
  N as au,
  Zt as av,
  rr as aw,
  O as ax,
  Sr as ay,
  Bt as az,
  Te as b,
  _t as c,
  jr as d,
  Or as e,
  qt as f,
  z as g,
  Ut as h,
  Rr as i,
  Xt as j,
  Tr as k,
  C as l,
  Er as m,
  Pr as n,
  Ce as o,
  ie as p,
  lr as q,
  $r as r,
  wr as s,
  xr as t,
  se as u,
  Pe as v,
  vr as w,
  nr as x,
  Xe as y,
  or as z
};
